import React, {Component} from 'react';
import {FormattedMessage} from "react-intl";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader, Tooltip} from "reactstrap";
import PropTypes from 'prop-types';
import LaddaButton, {ZOOM_OUT} from "react-ladda";
import EditForm from "./EditForm";
import {connect} from "react-redux";
import {updateUserPrize} from './../../actions';

class EditAction extends Component {

  constructor(props) {
    super(props);

    this.state = {
      tooltip: false,
      modal: false,
      loading: false,
      errors: {}
    };

    this.userPrizeForm = React.createRef();
    this.updateUserPrize = this.updateUserPrize.bind(this);
  }

  toggle(property) {
    this.setState({[property]: !this.state[property]})
  }

  updateUserPrize(e, data) {
    e.preventDefault();
    this.setState({loading: true});

    this.props.updateUserPrize({
      id: this.props.userPrize.id,
      data: data.userPrize
    }).then(() => {
      this.props.handleChange();
      this.setState({
        loading: false,
        modal: false
      })
    }).catch(e => {
      this.setState({
        loading: false,
        errors: e.response.data.form.errors
      });
    });
  }

  render() {
    return (
      <React.Fragment>
        <span id={'editUserPrize-' + this.props.userPrize.id} className="fas fa-edit mr-2" onClick={() => this.toggle('modal')}/>
        <Tooltip
          delay={0}
          placement="bottom"
          isOpen={this.state.tooltip}
          target={'editUserPrize-' + this.props.userPrize.id}
          toggle={() => this.toggle('tooltip')}
        >
          <FormattedMessage id="admin.userPrizes.editAction.tooltip" />
        </Tooltip>

        <Modal isOpen={this.state.modal} size="lg" toggle={() => this.toggle('modal')}>
          <ModalHeader toggle={() => this.toggle('modal')} tag="h2"><FormattedMessage id="admin.userPrizes.editAction.modalHeader"/></ModalHeader>
          <hr className="my-0" />
          <ModalBody>
            <EditForm userPrize={this.props.userPrize} errors={this.state.errors} onSubmit={this.updateUserPrize} ref={this.userPrizeForm} statuses={this.props.statuses}/>
          </ModalBody>
          <ModalFooter>
            <div className="direction-group d-flex justify-content-end">
              <div className="direction-right">
                <FormattedMessage id="_.button.save">{
                  (message) => <LaddaButton
                    className="btn btn-success btn-ladda mb-0 ml-3"
                    data-style={ZOOM_OUT}
                    onClick={e => this.updateUserPrize(e, this.userPrizeForm.current.state)}
                    loading={this.state.loading}
                  >
                    {message}
                  </LaddaButton>
                }</FormattedMessage>
                <FormattedMessage id="_.button.cancel">{
                  (message) => <Button color="secondary" className="mb-0 ml-3" onClick={() => this.toggle('modal')}>{message}</Button>
                }</FormattedMessage>
              </div>
            </div>
          </ModalFooter>
        </Modal>
      </React.Fragment>
    )
  }
}

EditAction.propTypes = {
  userPrize: PropTypes.object.isRequired,
  statuses: PropTypes.array.isRequired,
  handleChange: PropTypes.func.isRequired
};

export default connect(null, { updateUserPrize })(EditAction);